'use strict';

customerZone.service('InvoiceService', ['$q', 'UnleashedClient', 'Session', function($q, api, session){

    var self = this;

    self.getInvoices = function(page){
        return api.getInvoiceHistory(page);
    };

    self.getInvoicesByState = function(page, paid){
        return api.getInvoicesByState(page, paid);
    };

}]);
